import React, { useEffect, useRef, useState } from 'react';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { motion } from 'framer-motion';
import BeginingsIcon from '../assets/svgs/beginingsIcon';
import ProgrammingIcon from '../assets/svgs/programmingIcon';
import SubkontraktMediaIcon from '../assets/svgs/subkontraktMediaIcon';

export const StickyScroll = ({
  content,
  setSkillsBackground,
}: {
  content: {
    title: string;
    description: string;
  }[];
  setSkillsBackground: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [activeCard, setActiveCard] = React.useState(0);
  const ref = useRef<any>(null);
  const { scrollYProgress } = useScroll({
    container: ref,
    offset: ['start start', 'end start'],
  });
  const cardLength = content.length;

  useMotionValueEvent(scrollYProgress, 'change', latest => {
    const cardsBreakpoints = content.map((_, index) => index / cardLength);
    cardsBreakpoints.forEach((breakpoint, index) => {
      if (latest > breakpoint - 0.2 && latest <= breakpoint) {
        setActiveCard(() => index);
      }
    });
  });

  const backgroundColors = [
    'var(--slate-900)',
    'var(--black)',
    'var(--neutral-900)',
  ];
  const linearGradients = [
    'linear-gradient(to bottom right, var(--cyan-500), var(--emerald-500))',
    'linear-gradient(to bottom right, var(--red-200), var(--blue-200))',
    'linear-gradient(to bottom right, var(--pink-500), var(--indigo-500))',
    'linear-gradient(to bottom right, var(--orange-500), var(--yellow-500))',
  ];

  const SkillsImgs = [
    <BeginingsIcon width={`20rem`} height={`15rem`} />,
    <SubkontraktMediaIcon width={`20rem`} height={`15rem`} />,
    <ProgrammingIcon width={`20rem`} height={`15rem`} />,
    <BeginingsIcon width={`20rem`} height={`15rem`} />,
  ];
  useEffect(() => {
    setSkillsBackground(backgroundColors[activeCard % backgroundColors.length]);
  }, [backgroundColors]);
  return (
    <motion.div
      animate={{
        backgroundColor: backgroundColors[activeCard % backgroundColors.length],
      }}
      className={`h-full pt-0 pb-0 sm:pt-[25vh] sm:pb-[25vh] w-full overflow-y-auto flex justify-center relative space-x-10 gap-0 lg:gap-[20vw]`}
      ref={ref}
    >
      <div className='div relative flex items-start px-4'>
        <div className='max-w-2xl'>
          {content.map((item, index) => (
            <div key={item.title + index} className='my-28'>
              <motion.h2
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: activeCard === index ? 1 : 0.3,
                }}
                className='text-2xl font-bold text-slate-100'
              >
                {item.title}
              </motion.h2>
              {window.innerWidth < 650 && (
                <motion.div
                  animate={{
                    background: linearGradients[index],
                  }}
                  className='flex items-center justify-center p-3 lg:p-0 lg:block h-60 w-80 rounded-md bg-white m-auto my-2 overflow-hidden'
                >
                  {SkillsImgs[index]}
                </motion.div>
              )}
              <motion.p
                initial={{
                  opacity: 0,
                }}
                animate={{
                  opacity: activeCard === index ? 1 : 0.3,
                }}
                className='text-kg text-slate-300 max-w-sm mt-10'
              >
                {item.description}
              </motion.p>
            </div>
          ))}
          <div className='h-40' />
        </div>
      </div>
      {window.innerWidth > 650 && (
        <motion.div
          animate={{
            background: linearGradients[activeCard % linearGradients.length],
          }}
          className='flex items-center justify-center p-3 lg:p-0 lg:block h-60 w-80 rounded-md bg-white sticky top-10 overflow-hidden'
        >
          {SkillsImgs[activeCard]}
        </motion.div>
      )}
    </motion.div>
  );
};
